import React from 'react';

interface AnalyticsTabProps {
    handleForm: any;
}

const AnalyticsTab: React.FC<AnalyticsTabProps> = ({ handleForm }) => {
    return (
        <div className="mt-3">
            <div className="mb-4">
                <label htmlFor="userSessionDurationHours" className="form-label">Duração da sessão (horas)</label>
                <input
                    type="number"
                    className="form-control"
                    id="userSessionDurationHours"
                    name="userSessionDurationHours"
                    onChange={handleForm.handleChange}
                    value={handleForm.values.userSessionDurationHours}
                />
            </div>

            <hr className="my-4" />

            <div className="mb-4">
                <h6 className="mb-3">First Party Data</h6>
                <div className="alert alert-info">
                    <h6 className="alert-heading">Por que configurar um domínio customizado?</h6>
                    <p className="mb-2">
                        Configurar um subdomínio personalizado irá:
                    </p>
                    <ul className="mb-2">
                        <li>Melhorar a classificação da sua receita publicitária</li>
                        <li>Aumentar a duração dos cookies (até 400 dias vs 7 dias)</li>
                        <li>Fornecer dados de primeiro partido mais precisos para os compradores</li>
                    </ul>
                    <p className="mb-0">
                        <strong>Importante:</strong> Evite usar subdomínios óbvios como gtm, analytics, tracking, etc.
                    </p>
                </div>

                <div className="mb-3">
                    <label htmlFor="customDomain" className="form-label">
                        Subdomínio Customizado
                        <small className="text-muted ms-2">
                            (ex: {handleForm.values.domain ? `cdn0.${handleForm.values.domain}` : "cdn0.seusite.com"})
                        </small>
                    </label>
                    <input
                        type="text"
                        className={`form-control ${handleForm.touched.customDomain && handleForm.errors.customDomain ? 'is-invalid' : ''}`}
                        id="customDomain"
                        name="customDomain"
                        placeholder={handleForm.values.domain ? `cdn0.${handleForm.values.domain}` : "cdn0.seusite.com"}
                        onChange={handleForm.handleChange}
                        onBlur={handleForm.handleBlur}
                        value={handleForm.values.customDomain}
                    />
                    {handleForm.touched.customDomain && handleForm.errors.customDomain && (
                        <div className="invalid-feedback">{handleForm.errors.customDomain}</div>
                    )}
                </div>

                {handleForm.values.customDomain && (
                    <div className="mt-3">
                        <div className="alert alert-warning">
                            <h6 className="alert-heading">Configuração DNS Necessária</h6>
                            <p>Para que o subdomínio funcione corretamente, você precisa configurar um registro CNAME no seu DNS:</p>
                            <div className="bg-light p-2 rounded mb-2">
                                <code>
                                    {handleForm.values.customDomain} CNAME js.adpulse.io
                                </code>
                            </div>
                            <p className="mb-0">
                                <strong>Como configurar:</strong>
                                <br />
                                1. Acesse o painel de controle do seu provedor de DNS
                                <br />
                                2. Adicione um novo registro CNAME
                                <br />
                                3. Nome/Host: {handleForm.values.customDomain?.replace(`.${handleForm.values.domain}`, '') || 'exemplo'}
                                <br />
                                4. Valor/Target: js.adpulse.io
                            </p>
                        </div>
                    </div>
                )}

                {!handleForm.values.domain && (
                    <div className="alert alert-warning">
                        <strong>Atenção:</strong> Para configurar um domínio customizado, primeiro informe o site principal na aba "Configurações Gerais".
                    </div>
                )}
            </div>
        </div>
    );
};

export default AnalyticsTab;